<div class="w-100 bg-grey-200">
  <div class="ad-skin d-none d-xl-block">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adSkin"
    ></flo-lazy>
  </div>
  <div class="pt-3 pb-4 d-none d-lg-flex position-relative justify-content-center lazy-leaderboard-container">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="leaderboardLarge"
      [detectorHeight]="90"
    ></flo-lazy>
  </div>
  <main class="container container-fluid min-vh-100 pt-lg-4">
    <div
      class="pt-3 pb-4 d-none d-md-flex d-lg-none justify-content-center position-relative lazy-leaderboard-container"
    >
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="leaderboardSmall"
        [detectorHeight]="90"
      ></flo-lazy>
    </div>
    <h1 class="h3 mb-0 ps-lg-2" data-test="title">News</h1>
    <div class="row">
      <!-- desktop only - left side list of articles-->
      <div class="d-none d-md-block col-12 col-lg-8 pt-3 pt-sm-2 pe-3 px-lg-4">
        <div class="row py-3 pe-0 pe-md-1">
          <div class="col-6 pb-3" *ngFor="let article of firstTwoArticles; trackBy: trackByAnalyticsId">
            <a
              floAnalytics
              [analyticsProperties]="article.analytics"
              [routerLink]="article.contentItem.slug_uri"
              class="primary-color-text-hover"
            >
              <flo-spotlight
                *ngIf="article.contentItem.publish_start_date != null; else noDateSpotlight"
                [title]="article.contentItem.title"
                [imageUrl]="article.contentItem.asset_url"
                [premium]="article.analytics.is_premium"
                [publishDate]="article.contentItem.publish_start_date | isoStringToDate"
              ></flo-spotlight>
              <ng-template #noDateSpotlight>
                <flo-spotlight
                  [title]="article.contentItem.title"
                  [imageUrl]="article.contentItem.asset_url"
                  [premium]="article.analytics.is_premium"
                ></flo-spotlight>
              </ng-template>
            </a>
          </div>
        </div>
        <ul>
          <li class="w-100 py-md-3 list-item" *ngFor="let article of remainingArticles; trackBy: trackById">
            <flo-static-content-card [card]="article"></flo-static-content-card>
          </li>
        </ul>
        <div class="w-100 text-center mt-4 mb-5 pb-5">
          <button
            floAnalytics
            [name]="loadMoreButtonText"
            (click)="showMoreArticles.emit()"
            class="btn btn-primary"
            data-test="desktop-see-more"
          >{{ loadMoreButtonText }}</button>
        </div>
      </div>
      <!-- mobile only - left side list of articles-->
      <div class="d-block d-md-none col-12 pt-3 pt-sm-2 pe-3 pe-md-4">
        <ul>
          <li class="w-100 py-md-3 small-list-item" *ngFor="let article of allArticles; trackBy: trackByAnalyticsId">
            <a
              floAnalytics
              [analyticsProperties]="article.analytics"
              [routerLink]="article.contentItem.slug_uri"
              class="primary-color-text-hover"
            >
              <flo-content-small
                [title]="article.contentItem.title"
                [imgUrl]="article.contentItem.asset_url"
                [publishDate]="article.contentItem.publish_start_date | isoStringToDate"
              ></flo-content-small>
            </a>
          </li>
        </ul>
        <div class="w-100 text-center mb-5 pb-5">
          <button
            floAnalytics
            [name]="loadMoreButtonText"
            (click)="showMoreArticles.emit()"
            class="btn btn-primary"
            data-test="mobile-see-more"
          >{{ loadMoreButtonText }}</button>
        </div>
      </div>
      <!-- right rail -->
      <aside data-test="article-rail" class="d-none d-lg-block col-lg-4 pt-3 pt-sm-2 border-start">
        <div class="px-3 py-3 stick-to-header">
          <div class="d-none d-lg-flex justify-content-center lazy-flex-container">
            <flo-lazy
              [componentConstructor]="AdComponent"
              [initialProps]="rightRailFlex"
              [detectorHeight]="250"
              [threshold]="0.4"
            ></flo-lazy>
          </div>
          <div class="py-4">
            <flo-newsletter-widget></flo-newsletter-widget>
          </div>
        </div>
      </aside>
    </div>
  </main>
  <flo-adhesion-footer>
    <div class="adhesion-ad d-sm-none">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="adhesion"
      ></flo-lazy>
    </div>
  </flo-adhesion-footer>
</div>
